import { render } from "./ListadoMarcasDhs.vue?vue&type=template&id=c4b19362&scoped=true"
import script from "./ListadoMarcasDhs.vue?vue&type=script&lang=js"
export * from "./ListadoMarcasDhs.vue?vue&type=script&lang=js"

import "./ListadoMarcasDhs.vue?vue&type=style&index=0&id=c4b19362&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4b19362"]])

export default __exports__